import { createStyles } from 'antd-style';

const useStyles = createStyles(() => {
  return {
    'rowContainer': {
      display: 'flex',
      flexDirection: 'row',
      margin: '30px 0',
      alignItems: 'center',
      justifyContent: 'space-between',
    },
    'startFromTemplateSelect': {
      width: '450px',
    },
    'thoughtRow': {
      display: 'flex',
      marginBottom: '8px',
      alignItems: 'baseline',
      justifyContent: 'flex-start',
      flexWrap: 'wrap',
    },
    'thoughtRowInput': {
      width: '400px',
    },
    'thoughtWithMinus': {
      display: 'flex',
      alignItems: 'baseline',
    },
    'select-client-item': {
      width: '375px',
    },
    'card-form-item': {
      flex: '1',
      flexBasis: '300px',
    },
  };
});
export default useStyles;
